<template>
<div>
  <div class="home">
    <MainHeading :title="'Architecture'" :subtitle="'Portfolio'" />
  </div>

  <Showcase :showcase="'resume'" :items="resumeItems" :isDownload="true" @toggle-expand="toggleExpand" @expand-all="expandAll" @collapse-all="collapseAll" />
  <Contact />
  <Showcase :showcase="'work'" :items="workItems" :isDownload="false" />
</div>
</template>

<script src="./Home.js"></script>

<style lang="scss" src="./Home.scss"></style>
